import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { useDispatch } from "react-redux";
import {
  getChatbotChats,
  getDashboardChats,
  getDashboardReports,
  getDashboardStats,
} from "@root/store/thunks";

export function useDashboard() {
  const [statsLoading, setStatsLoading] = useState(false);
  const [chatsLoading, setChatsLoading] = useState(false);
  const [reportsLoading, setReportsLoading] = useState(false);
  const [stats, setStats] = useState<any>(null);
  const [reports, setReports] = useState<any>(null);
  const [chats, setChats] = useState<any>(null);
  const [search, setSearch] = useState("");
  const [PageNo, setPageNo] = useState(1);
  const [chatCount, setChatCount] = useState(1);
  const [reportCount, setReportCount] = useState(1);
  const [chatbotChats, setChatbotChats] = useState(null);
  const [chatbotChatsLoading, setChatbotChatsLoading] = useState(false);
  const [chatbotChatsCount, setChatbotChatsCount] = useState(0);
  const dispatch = useDispatch();

  const fetchStats = () => {
    setStatsLoading(true);
    dispatch(
      getDashboardStats({
        onSuccess: (response: any) => {
          setStatsLoading(false);
          setStats(response);
        },
        onError: (error: any) => {
          setStatsLoading(false);
          console.error("Error fetching stats:", error);
        },
      }) as any
    );
  };

  const fetchReports = (data: any) => {
    setReportsLoading(true);
    dispatch(
      getDashboardReports({
        data,
        onSuccess: (response: any, count: number) => {
          setReportsLoading(false);
          setReports(response);
          setReportCount(count);
        },
        onError: (error: any) => {
          setStatsLoading(false);
          console.error("Error fetching reports:", error);
        },
      })
    );
  };

  const fetchChats = (data: any) => {
    setChatsLoading(true);
    dispatch(
      getDashboardChats({
        data,
        onSuccess: (response: any, count: number) => {
          setChatsLoading(false);
          setChats(response);
          setChatCount(count);
        },
        onError: (error: any) => {
          setStatsLoading(false);
          console.error("Error fetching reports:", error);
        },
      })
    );
  };

  const fetchChatbotChats = (data: any) => {
    setChatbotChatsLoading(true);
    dispatch(
      getChatbotChats({
        data,
        onSuccess: (response: any, count: number) => {
          setChatbotChatsLoading(false);
          setChatbotChats(response);
          setChatbotChatsCount(count);
        },
        onError: (error: any) => {
          setChatbotChatsLoading(false);
          console.error("Error fetching reports:", error);
        },
      })
    );
  };

  return {
    fetchStats,
    fetchReports,
    fetchChats,
    fetchChatbotChats,
    setChatbotChatsLoading,
    chatbotChatsLoading,
    chatbotChats,
    chatbotChatsCount,
    chatsLoading,
    reportsLoading,
    reports,
    chats,
    statsLoading,
    search,
    PageNo,
    chatCount,
    reportCount,
    setPageNo,
    stats,
  };
}
